import { ThietLapDonHangMuaModel } from './../thiet-lap-don-hang-mua-model/thiet-lap-don-hang-mua.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
const API_ROOT_URL = environment.ApiRoot + '/thietlapdonhangmua';

@Injectable()
export class ThietLapDonHangMuaService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10, [], true));
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }


	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DanhSachDiaDiemGiaoHang', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	getDataInit(): Observable<QueryResultsModel>{
		const queryParams = new QueryParamsModel(
			{}, 'asc', '', 0, 10, [], true
		);
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DanhSachDiaDiemGiaoHang', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	addUpdateRemove(item: ThietLapDonHangMuaModel): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL+'/XuLyDiaDiemGiaoHang', item, { headers: httpHeaders });
	}

	updateDieuKienGiaoHang(data: string): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("DieuKienGiaoHangSetting", data.toString());
		return this.http.get<any>(API_ROOT_URL + '/XuLyDieuKienGiaoHang', { 
			headers: httpHeaders,
			params: httpParams
		});
	}

	getDieuKienGiaoHang(): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/XuLyDieuKienGiaoHang_Text', { 
			headers: httpHeaders
		});
	}

}
